const CUSTOMER_CASHIER_FEATURE_KEY = "customerCashier";
export {
  CUSTOMER_CASHIER_FEATURE_KEY
};
